module.exports = __webpack_public_path__ + "static/media/calendar.02228549.svg";